"use strict";

import angular from "angular";

import template from "./files-upload-pgdas-esocial.component.html";
import "./files-upload-pgdas-esocial.component.scss";

import _ from "lodash";
import { hasRegisteredCompaniesDialogTemplate } from "../../../views/accounting/company-create/company-create.dialog-templates";
import accountsRelationDialogTemplate from "../../../views/accounting/company/department/tax/dialogs/accounts-relation/accounts-relation.html";
import accountsEsocialRelationDialogTemplate from "../../../views/accounting/company/department/personnel/department-personnel-import/dialogs/accounts-esocial-relation-dialog/accounts-esocial-relation-dialog.html";
import { AccountingEntity } from "../../../entity/AccountingEntity";
import { CompanyEntity } from "../../../entity/CompanyEntity";
import { UserEntity } from "../../../entity/UserEntity";
import { Available } from "../../../gateway/Available/Available";
import { CalculatingMachineV2Gateway } from "../../../gateway/CalculatingMachineV2Gateway/CalculatingMachineV2Gateway";
import { Company } from "../../../gateway/Company/Company";
import { DashboardAvailable } from "../../../gateway/DashboardAvailable/DashboardAvailable";
import { ESocialHttpGateway } from "../../../gateway/ESocial/ESocialHttpGateway";
import { Insight } from "../../../gateway/Insight/Insight";
import { Point } from "../../../gateway/Point/Point";
import { PointCalculated } from "../../../gateway/PointCalculated/PointCalculated";
import { Serie } from "../../../gateway/Serie/Serie";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { XlsxAdapter } from "../../../presentation/adpters/XlsxAdapter/XlsxAdapter";
import { CalculatingMachine } from "../../../presentation/services/CalculatingMachine/CalculatingMachine";
import { DepartamentDonwnloadExcel } from "../../../presentation/services/DepartamentDonwnloadExcel/DepartamentDonwnloadExcel";
import { DepartmentPersonnelImportService } from "../../../presentation/services/DepartmentPersonnelImportService";
import { DepartmentTaxAndPersonnel } from "../../../presentation/services/DepartmentTaxAndPersonnel/DepartmentTaxAndPersonnel";
import { DepartmentUploadExcel } from "../../../presentation/services/DepartmentUploadExcel/DepartmentUploadExcel";
import { Events } from "../../../presentation/services/Events/Events";
import { ImportPGDAS } from "../../../presentation/services/ImportPGDAS/ImportPGDAS";
import { PopulateManager } from "../../../presentation/services/PopulateManager/PopulateManager";
import { Validators } from "../../../utils/validators/Validators";

export class filesUploadPgdasEscoialComponent {
    messageErrorImport = null;
    loadingImporting = false;
    dropOptions = {
        multiple: true,
        allowDir: false,
        accept: ".pdf",
        maxFiles: 12,
        maxSize: "12MB"
    };
    selectedTypeFile = {};
    filesSupported = [
        {
            name: "PGDAS (fiscal)",
            accept: ".pdf",
            value: "pgdas",
            maxSize: "12MB"
        },
        {
            name: "eSocial (pessoal)",
            accept: ".xml,.zip",
            value: "eSocial",
            maxSize: "100MB"
        }
    ];

    companyEntity = {};
    XlsxAdapter = new XlsxAdapter();
    DepartmentUploadExcel = new DepartmentUploadExcel({
        XlsxAdapter: this.XlsxAdapter
    });
    Available = new Available();
    ESocialHttpGateway = new ESocialHttpGateway();
    DepartamentDonwnloadExcel = new DepartamentDonwnloadExcel();
    CompanyDomain = new Company();
    Point = new Point();
    Insight = new Insight();
    PopulateManager = new PopulateManager();
    DashboardAvailable = new DashboardAvailable();
    PointCalculated = new PointCalculated();
    Events = new Events();
    ImportPGDAS = new ImportPGDAS({
        Company: this.CompanyDomain
    });

    constructor($scope, LoaderService, DesnuDialogService, $state, $rootScope) {
        this.$scope = $scope;
        this.LoaderService = LoaderService;
        this.DesnuDialogService = DesnuDialogService;
        this.$state = $state;
        this.$rootScope = $rootScope;

        this.Serie = new Serie({
            PopulateManager: this.PopulateManager
        });
        this.CalculatingMachine = new CalculatingMachine({
            Serie: this.Serie,
            Point: this.Point,
            PointCalculated: this.PointCalculated
        });
        this.DepartmentTaxAndPersonnel = new DepartmentTaxAndPersonnel({
            Serie: this.Serie,
            CalculatingMachine: this.CalculatingMachine
        });
        this.ESocialHttpGateway = new ESocialHttpGateway();
        this.DepartamentDonwnloadExcel = new DepartamentDonwnloadExcel();
        this.DepartmentPersonnelImportService = new DepartmentPersonnelImportService(
            {
                AvailableHttpGateway: this.Available,
                Events: this.Events,
                DepartmentUploadExcel: this.DepartmentUploadExcel,
                SerieHttpGateway: this.Serie,
                PointHttpGateway: this.Point,
                PopulateManager: this.PopulateManager,
                InsightHttpGateway: this.Insight,
                CompanyHttpGateway: this.CompanyDomain,
                DashboardAvailableHttpGateway: this.DashboardAvailable,
                DepartmentTaxAndPersonnel: this.DepartmentTaxAndPersonnel,
                DepartamentDonwnloadExcel: this.DepartamentDonwnloadExcel,
                ESocialHttpGateway: this.ESocialHttpGateway,
                CalculatingMachineV2Gateway: new CalculatingMachineV2Gateway()
            }
        );
    }

    $onInit() {
        this.selectedTypeFile = this.filesSupported[0];
        this.companyEntity = new CompanyEntity(this.companyData);
    }

    onGetSelectedtTypeName() {
        return this.selectedTypeFile.value === "pgdas" ? "PGDAS" : "eSocial";
    }

    onChangeTypeFile(supported) {
        this.files = [];
        this.dropOptions.accept = supported.accept;
        this.dropOptions.maxSize = supported.maxSize;
    }

    onDropFile(files) {
        const status = this.onValidateFilesImport(files, this.selectedTypeFile);

        if (status) {
            this.files = files;
            this.messageErrorImport = "";
        }
    }

    onRemoveFile(index) {
        if (this.files[index]) {
            this.files.splice(index, 1);
        }
    }
    onAddNewFiles(files) {
        const status = this.onValidateFilesImport(files, this.selectedTypeFile);
        if (files.length && status) this.files = this.files.concat(files);
        this.messageErrorImport = null;
    }

    onValidateFilesImport(files, selectedTypeFile) {
        const isAllowed = Validators.isValidFile(
            files,
            selectedTypeFile.accept.split(",")
        );

        if (!isAllowed) {
            this.messageErrorImport =
                "O arquivo que esta tentando importar é inválido";
            return false;
        }

        return true;
    }

    async onImportFiles() {
        this.LoaderService.setProgress(true);
        this.loadingImporting = true;

        this.onImportData(this.files, this.selectedTypeFile);
    }

    onImportData(files, selectedTypeFile) {
        const status = this.onValidateFilesImport(files, selectedTypeFile);

        if (!status) return;

        switch (selectedTypeFile.value) {
            case "pgdas":
                const fileName = _.get(files, "[0].name");
                const isPDF = fileName.indexOf("pdf") > -1;
                if (isPDF) this.readAndConvertFilesToBase64(files);
                break;

            case "eSocial":
                const isPdfValid = Validators.isValidFile(files, [".pdf"]);
                if (isPdfValid) return;
                const typeOfImport = this.DepartmentPersonnelImportService.typeOfImport(
                    files
                );

                if (
                    typeOfImport === "eSocial" ||
                    this.DepartmentPersonnelImportService.accountPlanCurrent
                        .value === "eSocial"
                ) {
                    if (
                        this.DepartmentPersonnelImportService
                            .hasAvailableESocial
                    ) {
                        this.analysisESocial(files);
                    } else {
                        this.analysisESocial(files);
                    }
                } else {
                    this.analysisDefault(files);
                }

                break;
        }

        this.messageErrorImport = "";
        this.$scope.$applyAsync();
    }

    async analysisESocial(files) {
        this.loading = true;

        await this.DepartmentPersonnelImportService.analysisESocial({
            files
        });

        const accountingEntity = new AccountingEntity(this.accountingData);
        const userEntity = new UserEntity(new UserDataAdapter().user());

        const response = await this.DepartmentPersonnelImportService.importDataESocial(
            {
                accounting: accountingEntity,
                user: userEntity,
                isCreateCompany: true
            }
        );

        if (response?.eSocialIsNotValid) {
            this.messageErrorImport =
                "Um dos arquivos que você esta tentando importar não é eSocial.";
            this.loading = false;
            this.LoaderService.setProgress(false);
            this.loadingImporting = false;
            this.files = [];

            this.$scope.$applyAsync();
            return;
        }

        const hasDuplicated = this.DepartmentPersonnelImportService.hasCompaniesDuplicatedUpload();

        if (hasDuplicated) {
            this.setNandaImported();
        }

        if (response[0]?.companiesHasCreated) {
            this.messageErrorImport =
                "As empresas que você está importando já existe.";

            this.loading = false;
            this.loadingImporting = false;
            this.LoaderService.setProgress(false);
            this.$scope.$applyAsync();

            return;
        } else if (response?.length > 1) {
            this.$state.go(
                "nucont.accounting.overview.portfolio.companies.resume"
            );
        } else {
            this.openDialogCompaniesHasregistereds(response[0]);
        }

        this.loading = false;
        this.loadingImporting = false;
        this.messageErrorImport = "";
        this.LoaderService.setProgress(false);
        this.$scope.$applyAsync();
    }

    setNandaImported() {
        this.$rootScope.$broadcast(
            "SET_NANDA_NOTIFICATION",
            "UPLOAD_FILES_PGDAS_ESOCIAL"
        );

        setTimeout(() => {
            this.$rootScope.$broadcast("SET_NANDA_NOTIFICATION", "CLEAR");
        }, 5000);
    }

    async analysisDefault(files) {
        this.loading = true;

        this.LoaderService.setProgress(true);

        const response = await this.DepartmentPersonnelImportService.analysisDefault(
            {
                files,
                company: this.companyEntity
            }
        );

        if (_.get(response, "error")) {
            if (response.error.name === "SheetException") {
                this.importComponentConfigs.error = {
                    message: response.error.message
                };
            } else {
                this.importComponentConfigs.error = {
                    message: "Tente novamente."
                };
                console.error(response);
            }

            this.importComponentConfigs.step = 2;
        } else {
            this.importComponentConfigs.step = 1;
        }

        setTimeout(() => {
            this.DepartmentPersonnelImportService.current.monthsImporting.forEach(
                (value, index, array) => {
                    array[index].actions.loading = false;
                    array[index].actions.success = true;
                }
            );

            this.loading = false;

            this.LoaderService.setProgress(false);

            this.$scope.$applyAsync();
        }, 3000);
    }

    readAndConvertFilesToBase64(files) {
        this._setMonthsImporting(files);

        const filesToImport = [];
        const originalFiles = [];

        files.forEach((file) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = async () => {
                filesToImport.push(
                    reader.result.replace("data:", "").replace(/^.+,/, "")
                );

                originalFiles.push(reader.result);

                if (files.length === filesToImport.length) {
                    this.importPGDAS(filesToImport, originalFiles);
                    this.$scope.$applyAsync();
                }
            };

            reader.onerror = (error) => {
                console.error("Error: ", error);
            };
        });
    }
    async importPGDAS(files, originalFiles) {
        try {
            const response = await this.ImportPGDAS.import({
                accountingId: this.accountingData._id,
                files,
                originalFiles,
                isCreated: true
            });

            if (this.ImportPGDAS.hasDuplicateImportCompanies()) {
                this.setNandaImported();
            }

            if (response[0].companiesHasCreated) {
                this.messageErrorImport =
                    "As empresas que você está importando já existe.";
            } else if (response?.length > 1) {
                this.$state.go(
                    "nucont.accounting.overview.portfolio.companies.resume"
                );
            } else {
                this.openDialogCompaniesHasregistereds(response[0]);
            }
            this.LoaderService.setProgress(false);
            this.loadingImporting = false;
            this.files = [];
        } catch (err) {
            console.log(err);
            this.LoaderService.setProgress(false);
            this.loadingImporting = false;
        }
    }

    async openDialogCompaniesHasregistereds({ companyId }) {
        this.DesnuDialogService.custom({
            controller: "HasRegisteredCompaniesDialogCtrl",
            controllerAs: "$ctrl",
            escapeToClose: false,
            clickOutsideToClose: true,
            locals: {
                title: "",
                width: "543px",
                templateHtml: hasRegisteredCompaniesDialogTemplate
            },
            after: {
                hide: () => {
                    this.LoaderService.open();
                    this.$state.go("nucont.accounting.company", {
                        accountingId: this.accountingData._id,
                        id: companyId
                    });
                },
                cancel: () => {}
            }
        });
    }

    openDialogPGDAS(files, openWarn = false) {
        this.DesnuDialogService.custom({
            controller: "AccountsRelationCtrl as $ctrl",
            multiple: true,
            skipHide: true,
            escapeToClose: false,
            clickOutsideToClose: true,
            locals: {
                title: "Relação de contas - Resumo ",
                width: "590px",
                templateHtml: accountsRelationDialogTemplate
            },
            after: {
                hide: () => {
                    if (openWarn) this.onWarnImportType(files);
                },
                cancel: () => {
                    if (openWarn) this.onWarnImportType(files);
                }
            }
        });
    }

    _setMonthsImporting(files = []) {
        if (!files.length) this.monthsImporting = [];

        this.monthsImporting = files.map((file) => {
            return {
                fileName: file.name,
                month: "",
                actions: { remove: false, success: false, loading: true }
            };
        });

        this.$scope.$applyAsync();
    }

    accountsESocialRelation(files = []) {
        this.DesnuDialogService.custom({
            controller: "AccountsESocialRelationDialogCtrl as $ctrl",
            escapeToClose: false,
            clickOutsideToClose: false,
            locals: {
                title: "Relação de eventos",
                width: "609px",
                templateHtml: accountsEsocialRelationDialogTemplate
            },
            after: {
                hide: async () => {
                    if (files.length) this.analysisESocial(files);
                },
                cancel: async () => {
                    if (files.length) this.analysisESocial(files);
                }
            }
        });
    }
}

filesUploadPgdasEscoialComponent.$inject = [
    "$scope",
    "LoaderService",
    "DesnuDialogService",
    "$state",
    "$rootScope"
];

const name = "filesUploadPgdasEsocialComponent";
const def = {
    bindings: {
        accountingData: "<",
        companyData: "<"
    },
    controller: filesUploadPgdasEscoialComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
